import { oSelectbox } from 'Lib/selectbox/selectbox';
import { isTouch } from 'Lib/istouch/istouch';
import { speed } from 'Lib/speed/speed';
import { eventSender } from 'Lib/event-sender/event-sender';

const $manuscriptForm = $('.manuscript-form');
let emailSuccess = false;
let emailBaseCheck = false;
let ganresData = {};
const host = $manuscriptForm.attr('data-host');
const formRequestUrl = `/ajax/author_form/genre.php`;
let sumErrorEmailCode = 0;
// Валидация
// var current = 0;
let current = parseInt($manuscriptForm.attr('data-stage')) - 1;

$.validator.addMethod('stageRequired', function (value, element) {
    function match(index) {
        return current === index && $(element).parents(`.manuscript-form__fields-set[data-set="${index + 1}"]`).length;
    }

    if (match(0) || match(1) || match(2)) {
        return !this.optional(element);
    }

    return 'dependency-mismatch';
}, $.validator.messages.required);

const v = $('.manuscript-form__form').validate({
    errorClass: 'manuscript-form__validate-warning',
    onkeyup: false,
    onfocusout: false,
    ignore: [], // скрытые поля тоже отправляем (необходимо для selectbox)
});
// end Валидация

// Запрашиваем массив жанров
if ($manuscriptForm.length > 0) {
    $.ajax({
        type: 'GET',
        data: { rubricator: true/* , db:'y' */ },
        url: formRequestUrl,
        success(data) {
            ganresData = eval(`[${data}]`)[0]; // eslint-disable-line no-eval
        },
        error() {
            $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка 1 при запросе списка жанров</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
        },
    });
}

// Проверяем расширение и вес загружаемого файла рукописи
$('.manuscript-form__input_file').on('change', function () {
    if (!this.files) {
        return;
    }

    const fileName = this.files[0].name;

    if (fileName.length !== 0) {
        if (fileName.substr(-5, 5) !== '.docx') {
            $('.manuscript-form__input_file').val('');
            $.fancybox.open('<div class="manuscript-form__message"><p>Необходимо расширение файла ".docx"</p></div>');
        } else if (this.files[0].size > 31457280) {
            $('.manuscript-form__input_file').val('');
            $.fancybox.open('<div class="manuscript-form__message"><p>Файл не должен превышать 30 Мбайт.</p></div>');
        }
    }
});

// Проверяем расширение и вес загружаемого файла синопсиса
$('.manuscript-form__input_sinopsis').on('change', function () {
    if (!this.files) {
        return;
    }

    const fileName = this.files[0].name;

    if (fileName.length !== 0) {
        if (fileName.substr(-5, 5) !== '.docx') {
            $('manuscript-form__input_sinopsis').val('');
            $.fancybox.open('<div class="manuscript-form__message"><p>Необходимо расширение файла ".docx"</p></div>');
        } else if (this.files[0].size > 10485760) {
            $('.manuscript-form__input_file').val('');
            $.fancybox.open('<div class="manuscript-form__message"><p>Файл не должен превышать 10 Мбайт.</p></div>');
        }
    }
});

// Переключения этапов
$(document).on('click', '.manuscript-form__btn-next-stage:not(.btn_disabled)', function () {
    const $this = $(this);
    const nextStage = parseInt($this.attr('data-show-set'));
    const $stageNavEl = $('.manuscript-form__stage');
    const cPastStageNavEl = 'manuscript-form__stage_past';
    const cCurrentStageNavEl = 'manuscript-form__stage_current';
    const $segmentSelectboxBlock = $('.manuscript-form__selectbox-segment-block');

    if (nextStage === 2) {
        // console.log('v.form()', v.form(), v.element('#manuscript-form-agreement'), v);
        if (v.form()) {
            if (emailSuccess === true) {
                $('.manuscript-form').attr('data-stage', nextStage);
                $('html, body').scrollTop(0);
                current = 1;
                $stageNavEl.eq(0).removeClass(cCurrentStageNavEl).addClass(cPastStageNavEl);
                $stageNavEl.eq(1).addClass(cCurrentStageNavEl);
            } else if (emailBaseCheck === true) {
                $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста подтвердите код из письма</p></div>');
            } else {
                $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста подтвердите свой E-mail нажав на кнопку "Проверить E-mail"</p></div>');
            }
        } else {
            $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста заполните обязательные поля</p></div>');
        }
    } else if (nextStage === 3) {
        if (v.form()) {
            // Проверяем корректность введенной даты рождения
            if (validDate($('.manuscript-form__input_date-birth').val())) {
                // Проверяем выбран ли вариант резидентства
                if ($('#resident-radio_1').prop('checked') || $('#resident-radio_2').prop('checked')) {
                    $('.manuscript-form').attr('data-stage', nextStage);
                    $('html, body').scrollTop(0);
                    current = 2;
                    $stageNavEl.eq(1).removeClass(cCurrentStageNavEl).addClass(cPastStageNavEl);
                    $stageNavEl.eq(2).addClass(cCurrentStageNavEl);
                    // Добавляем селектбокс выбора сегмента
                    $segmentSelectboxBlock.html(selectboxBuilding(ganresData.SEGMENT, 'segment', true));
                    oSelectbox.init('.selectbox');

                    eventSender.customDL({
                        event: 'eksmo',
                        eventAction: 'send_form',
                        eventCategory: 'Заявка на рассмотрение рукописи',
                        eventLabel: 'Об авторе',
                    });
                } else {
                    $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста укажите вариант резидентства</p></div>');
                }
            } else {
                $.fancybox.open('<div class="manuscript-form__message"><p>Некорректная дата в поле "Дата рождения"</p></div>');
            }
        } else {
            $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста заполните обязательные поля</p></div>');
        }
    } else if (nextStage === 4) {
        if (v.form()) {
            $this.addClass('btn_disabled');
            sendForm();
            current = 3;
            $stageNavEl.eq(2).removeClass(cCurrentStageNavEl).addClass(cPastStageNavEl);
            $stageNavEl.eq(3).addClass(cCurrentStageNavEl);

            eventSender.customDL({
                event: 'eksmo',
                eventAction: 'send_form',
                eventCategory: 'Заявка на рассмотрение рукописи',
                eventLabel: 'Отправка рукописи',
            });
        } else if (v.element('#manuscript-form-agreement') === false) {
            $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста подтвердите свое согласие с "Пользовательским соглашением", "Политикой обработки персональных данных" и "Условиями рассмотрения рукописи"</p></div>');
        } else {
            $.fancybox.open('<div class="manuscript-form__message"><p>Пожалуйста заполните обязательные поля</p></div>');
        }
    }
});

// Выбор соцсети
$('.manuscript-form__social-network-items').on('changed.selectbox.eksmo', '.selectbox', function () {
    const $this = $(this);
    const $select = $this.find('.manuscript-form__social-network-select');
    const $itemsBlock = $this.closest('.manuscript-form__social-network-items');
    const $linkInput = $this.closest('.manuscript-form__social-network-item').find('.manuscript-form__social-network-link-input');
    const value = $select.val().toLowerCase();
    const preValue = $select.attr('data-pre-val');

    if (value !== '') {
        // Указываем родителю какая соцсеть выбрана, чтобы в css скрыть option-ы с этой соцсетью
        $itemsBlock.attr(`data-${value}`, 'selected');
        // Показываем текстовое поле под select-ом
        $linkInput.prop('disabled', false).show();
    } else {
        // Скрываем текстовое поле под select-ом
        $linkInput.prop('disabled', true).hide();
    }

    if (preValue !== undefined && preValue.length) {
        // Убираем у родителя информацию предыдущей выбранной соцсети, чтобы в css показать option-ы с этой соцсетью
        $itemsBlock.removeAttr(`data-${preValue}`);
    }

    $select.attr('data-pre-val', value);
});

// Добавление блока соцсетей
$('.manuscript-form__add-social-network:not(.btn_disabled)').on('click', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $items = $this.closest('.manuscript-form__input-item').find('.manuscript-form__social-network-items');
    const itemNum = $items.find('.manuscript-form__social-network-item').length + 1;

    $items.append(
        `<div class="manuscript-form__social-network-item">
            <div class="selectbox">
                <select name="social_network_${itemNum}" class="manuscript-form__social-network-select">
                    <option value=""></option>
                    <option value="Facebook" data-value="Facebook">Facebook</option>
                    <option value="Instagram" data-value="Instagram">Instagram</option>
                    <option value="Vkontakte" data-value="Vkontakte">Vkontakte</option>
                    <option value="Youtube" data-value="Youtube">Youtube</option>
                </select>
            </div>

            <div class="r"></div>

            <input type="text" name="social_network_link_${itemNum}" maxlength="250" placeholder="http://" class="input manuscript-form__social-network-link-input" disabled>
        </div>`,
    );

    oSelectbox.init('.selectbox');

    if (itemNum >= 4) {
        $this.hide();
    }
});

// Выбор сегмента
$manuscriptForm.on('changed.selectbox.eksmo', '.manuscript-form__selectbox-segment', (e, value) => {
    const $ganres = $('.manuscript-form__block_ganres');
    const $ganreSelectboxBlock = $('.manuscript-form__selectbox-ganre-block');
    const $subganres = $('.manuscript-form__subganres');
    const $subganreSelectboxBlock = $('.manuscript-form__selectbox-subganre-block');

    if (value !== undefined) {
        if (value !== '' && ganresData[`GANRE_${value}`] !== undefined) { // Если сегмент выбран и есть список жанров
            $ganreSelectboxBlock.html(selectboxBuilding(ganresData[`GANRE_${value}`], 'ganre', true));
            $ganres.show();
            oSelectbox.init('.selectbox');
        } else {
            $ganreSelectboxBlock.html('');
            $ganres.hide();
            $subganreSelectboxBlock.html('');
            $subganres.hide();
        }
    }
});

// Выбор жанра
$manuscriptForm.on('changed.selectbox.eksmo', '.manuscript-form__selectbox-ganre', (e, value) => {
    const $subganres = $('.manuscript-form__subganres');
    const $subganreSelectboxBlock = $('.manuscript-form__selectbox-subganre-block');

    if (value !== undefined) {
        if (value !== '' && ganresData[`SUBGANRE_${value}`] !== undefined) { // Если жанр выбран и есть список поджанров
            $subganreSelectboxBlock.html(selectboxBuilding(ganresData[`SUBGANRE_${value}`], 'subganre'));
            $subganres.show();
            oSelectbox.init('.selectbox');
        } else {
            $subganreSelectboxBlock.html('');
            $subganres.hide();
        }
    }
});

// Ввод E-mail
$('.manuscript-form__input_email').on('keyup', function () {
    const $this = $(this);
    const $checkButtonBlock = $('.manuscript-form__email-check-button-block');

    v.element($this);

    if ($this.valid()) {
        $checkButtonBlock.show();
    } else {
        $checkButtonBlock.hide();
    }
});

// Проверка Email по кнопке
$(document).on('click', '.manuscript-form__email-check-button:not(.btn_disabled)', function () {
    const $this = $(this);
    const $email = $('.manuscript-form__input_email');
    const email = $email.val();
    const $emailBlock = $email.closest('.manuscript-form__input-item');
    const $customError = $emailBlock.find('p.manuscript-form__validate-warning');
    const $timerBlock = $this.closest('.manuscript-form__email-check-button-block').find('.manuscript-form__load-block');
    let requestComplite = false;
    let timerEnd = false;

    $timerBlock.show();
    $this.addClass('btn_disabled');

    timer($timerBlock, () => {
        timerEnd = true;

        // Включаем кнопку после истечения таймера если выполнен ajax-запрос
        if (requestComplite) {
            $this.removeClass('btn_disabled');
        }

        $timerBlock.hide();
    });

    $.ajax({
        type: 'GET',
        data: { email: email},
        url: `/ajax/author_form/email_check.php`,
        success(data) {
            data = JSON.parse(data);

            if (data.user !== undefined) {
                $('.manuscript-form__input-item_mail-code').show();
                $customError.remove();

                if (data.user === true) {
                    $emailBlock.append('<p class="manuscript-form__validate-warning manuscript-form__validate-warning_green">Вы уже зарегистрированы в системе, мы отправили на этот адрес код подтверждения</p>');
                } else {
                    $emailBlock.append('<p class="manuscript-form__validate-warning manuscript-form__validate-warning_green">Вы еще не зарегистрированы в системе, мы отправили на этот адрес код подтверждения</p>');
                }

                emailBaseCheck = true;
            } else if (typeof data.error === 'string') {
                $.fancybox.open(`<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка</p><p>"${data.error}"</p></div>`);
            } else {
                $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка 21</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
            }
        },
        error() {
            $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка 22</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
        },
        complete() {
            requestComplite = true;

            // Включаем кнопку после выполнения ajax-запроса если истек таймер
            if (timerEnd) {
                $this.removeClass('btn_disabled');
            }
        },
    });
});

// Проверка Email-кода по кнопке
$(document).on('click', '.manuscript-form__email-code-button:not(.btn_disabled)', function () {
    const $this = $(this);
    const $emailInput = $('.manuscript-form__input_email');
    const $imailBlock = $emailInput.closest('.manuscript-form__input-item');
    const email = $emailInput.val();
    const $code = $('.manuscript-form__input_email-code');
    const code = $code.val();
    const cError = 'input_error';
    const $timerBlock = $this.closest('.manuscript-form__email-code-button-block').find('.manuscript-form__load-block');

    $this.addClass('btn_disabled');

    $.ajax({
        type: 'GET',
        data: { email: email, code: code},
        url: `/ajax/author_form/email_check.php`,
        success(data) {
            data = JSON.parse(data);
            if (data.user === true) {
                $code.removeClass(cError);
                $('.manuscript-form__input-item_mail-code').hide().prop('disabled', true); // disabled чтобы не отправилось и не было обязательным
                $('.manuscript-form__email-check-button-block').hide();
                $emailInput.addClass('input_success').prop('disabled', true);

                // Скрытое поле с email для отправки на сервер
                $imailBlock.append(`
                    <input type="email" name="email" value="${email}" style="display:none;">
                `);

                $imailBlock.find('p.manuscript-form__validate-warning').remove();
                emailSuccess = true;
                sendVerifiedEmail(email);
            } else {
                $code.addClass(cError);
                sumErrorEmailCode++;

                if (sumErrorEmailCode >= 2) {
                    $timerBlock.show();

                    timer($timerBlock, () => {
                        $this.removeClass('btn_disabled');
                        $timerBlock.hide();
                    });
                }
            }
        },
        error() {
            $code.addClass(cError);
        },
        complete() {
            // Включаем кнопку после выполнения ajax-запроса если запросов с ошибкой было меньше 2
            if (sumErrorEmailCode < 2) {
                $this.removeClass('btn_disabled');
            }
        },
    });
});

// Валидация E-mail (без jquery.validation)
// function isEmail(email) {
//     var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
//     return regex.test(email);
// }

// Нажатие на информационную иконку на тач устройстве
if (isTouch()) {
    const cInfoPopupShow = 'manuscript-form__info-popup--show';

    $('.manuscript-form__info-icon').on('click', function () {
        $(this).closest('.manuscript-form__info').find('.manuscript-form__info-popup').addClass(cInfoPopupShow);
    });

    $('.manuscript-form__info-popup-close').on('click', function () {
        $(this).closest('.manuscript-form__info').find('.manuscript-form__info-popup').removeClass(cInfoPopupShow);
    });
}

// Выбор селекта серии
$('.manuscript-form__selectbox-series').on('changed.selectbox.eksmo', function (e, value) {
    const $this = $(this);
    const $formBlock = $this.closest('.manuscript-form__block');
    const $inputNewSeriesBlock = $formBlock.find('.manuscript-form__input-series-block');
    const $inputNewSeries = $formBlock.find('.manuscript-form__input-series');

    if (value === 'NEW') {
        $inputNewSeriesBlock.show();
        $inputNewSeries.prop('disabled', false);
    } else {
        $inputNewSeriesBlock.hide();
        $inputNewSeries.prop('disabled', true);
    }
});

// Обработка ввода названия новой серии
$('.manuscript-form__input-series').on('change keyup paste', function (e) {
    const $this = $(this);
    const $errorCoincidence = $this.siblings('.manuscript-form__error-coincidence-series');
    const seriesList = [];

    $this.closest('.manuscript-form__block').find('.manuscript-form__selectbox-series option').each((index, object) => {
        const text = $(object).text();

        if (text !== '' && text !== ' ' && text !== 'Создать новую серию') {
            seriesList.push(text.toLowerCase());
        }
    });

    // кнопки, не обновляющие список такие как alt и shift
    if (![40, 38, 27, 13, 16, 17, 18, 19, 20, 33, 34, 35, 36, 37, 39, 44, 45, 91, 144].includes(e.keyCode)) {
        if (seriesList.includes($.trim($this.val()).toLowerCase())) {
            $errorCoincidence.slideDown(speed);
        } else {
            $errorCoincidence.slideUp(speed);
        }
    }
});

// Отправка формы
function sendForm() {
    const $form = $('.manuscript-form__form')[0];
    const formdata = new FormData($form);

    $.ajax({
        type: 'POST',
        url: `/ajax/author_form/send.php`,
        data: formdata,
        dataType: 'json',
        processData: false,
        contentType: false,
        success(data) {
            if (typeof data.error === 'string') {
                $.fancybox.open(`<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка</p><p>"${data.error}"</p></div>`);
            } else {
                if (data.id !== undefined) {
                    $('.manuscript-form__services-author .services-author__submit').attr('data-manuscript-id', data.id);
                }

                $('.manuscript-form').attr('data-stage', '4');
                $('html, body').scrollTop(0);
                // $form.reset();
                $($form).find('input[name]').val('');
            }
        },
        error() {
            $.fancybox.open('<div class="manuscript-form__message"><p class="text text_c-gray">Ошибка 3</p><p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p></div>');
        },
        complete() {
            $('.manuscript-form__btn-next-stage[data-show-set="4"]').removeClass('btn_disabled');
        },
    });
}

// Построение html селектбокса
function selectboxBuilding(data, type, required) {
    let html = '';
    let requiredClass = '';

    if (required) {
        requiredClass = 'stageRequired';
    }

    if (data !== undefined) {
        if (data.length !== 0) {
            html =
                `<div class="selectbox manuscript-form__selectbox-${type}">`
                + `   <select name="${type}" class="${requiredClass}" title="Это поле обязательно для заполнения!">`
                + `       <option value=""></option>`;

            data.forEach((item, i, arr) => {
                html += `<option value="${item.VALUE}">${item.NAME}</option>`;

                if (i === arr.length - 1) {
                    html += '</select></div>';
                }
            });
        }
    }

    return html;
}

// Проверка корректности даты
function validDate(date) { // Date в формате 31.12.2014
    const dArr = date.split('.');
    const d = new Date(`${dArr[2]}/${dArr[1]}/${dArr[0]}`); // дата в формате 2014/12/31

    return !(
        parseInt(dArr[2]) !== d.getFullYear()
        || parseInt(dArr[1]) !== (d.getMonth() + 1)
        || parseInt(dArr[0]) !== d.getDate()
    ); // Корректная ли дата
}

// Таймер
function timer($timerBlock, callback) {
    const $timerText = $timerBlock.find('.manuscript-form__load-text');
    let seconds = +$timerText.text();
    const memorySeconds = seconds;
    const int = setInterval(() => {
        if (seconds > 1) {
            seconds--;
            $timerText.text(seconds);
        } else {
            clearInterval(int); // очищаем интервал, чтобы он не продолжал работу при _Seconds = 0
            $timerText.text(memorySeconds); // Восстанавливаем исходное значение в верстке
            callback();
        }
    }, 1000);
}

// Отправка подтвержденного email в /authors/form.php
function sendVerifiedEmail(email) {
    $.ajax({
        type: 'POST',
        url: '/authors/form.php',
        data: email,
        dataType: 'json',
        processData: false,
        contentType: false,
        success() {
            console.log('/authors/form.php ajax: success');
        },
        error() {
            console.log('/authors/form.php ajax: error');
        },
        complete() {
        },
    });
}